<template>
  <div>
    <GridSyclus
      :idRecursoSistema="args.idRecursoSistema"
      title="Tipos Situações"
      :headers="tipoSituacaoHeaders"
      :customHeaders="customHeaders"
      :items="tiposSituacao"
      item-key="IdTipoSituacao"
      :loading="loading"
      @aplicaFiltros="aplicaFiltros"
      @abreModalGridSyclus="abreModalGridSyclus"
      @changeLayoutSql="changeLayoutSql"
      @editItemSelected="editItemSelected"
      @deleteItemSelected="deleteItemSelected"
    />
    <ModalCadastroTipoSituacao 
      v-model="modalTipoSituacao"
      :tipoSituacao="tipoSituacao"
      @tipoSituacaoAdicionado="tipoSituacaoAdicionado"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridSyclus from '@/components/shared/GridSyclus';
import TipoSituacao from '@/domain/tipoSituacao/TipoSituacao';
import ModalCadastroTipoSituacao from '@/components/tipoSituacao/ModalCadastroTipoSituacao';
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'TiposSituacaoView',
  components: {
    GridSyclus,
    ModalCadastroTipoSituacao
  },
  data() {
    return {
      args: {
        usuario: JSON.parse(localStorage.getItem('user')),
        idLayoutSql: null,
        colaboradores: [],
        status: ['P'],
        dataInicial: null,
        dataFinal: null,
        idRecursoSistema: 100013
      },
      tipoSituacaoHeaders: [
        { text: "ID", value: "IdTipoSituacao" },
        { text: "Descrição", value: "Descricao" },
        { text: "Status", value: "Status" },
      ],
      customHeaders: ["Status"],
      loading: false,
      modalTipoSituacao: false,
      tipoSituacao: new TipoSituacao()
    }
  },
  computed: {
    ...mapGetters(['user', 'tiposSituacao']),
  },
  methods: {
    ...mapMutations(["showNotification", "closeNotification"]),
    ...mapActions([
      'fetchTiposSituacaoSql',
      'fetchLayoutsSqlUsuario',
      'deleteTipoSituacao',
    ]),
    async aplicaFiltros() {
      this.loading = true;
      await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: 100013 });
      await this.fetchTiposSituacaoSql(this.args);
      this.loading = false;
    },
    changeLayoutSql(payload) {
      this.args.idLayoutSql = payload;
    },
    abreModalGridSyclus() {
      this.modalTipoSituacao = true;
      this.tipoSituacao = Object.assign({}, new TipoSituacao());
    },
    editItemSelected(payload) {
      if (payload && payload.IdTipoSituacao) {
        this.tipoSituacao = payload;
        this.modalTipoSituacao = true;
      } else if (payload.length) {
        this.tipoSituacao = payload[payload.length - 1];
        this.modalTipoSituacao = true;
      } else {
        this.showNotification({ text: "Selecione um tipo situação para alterar.", status: 'error' });
      }
    },
    deleteItemSelected(payload) {
      if (payload.length) {
        if (confirm(`Tem certeza que deseja excluir: ${payload.length} registros?`)) {
          let promises = [];

          payload.forEach(item => {
            promises.push(this.deleteTipoSituacao(item.IdTipoSituacao));
          });
          Promise.all(promises)
            .then(() => {
              this.showNotification({ text: `Operação concluída com sucesso.`, status: 'success' });
            })
            .catch(error => {
              this.loading = false;
              console.log(error);
              this.showNotification({ text: `Ocorreu um erro ao excluir os tipos situação: ${error}`, status: 'error' });
            });
        } else {
          this.showNotification({ text: `Operação cancelada.`, status: 'error' });
        }
      } else {
        this.showNotification({ text: 'Selecione pelo menos um tipo situação para excluir.', status: 'error' });
      }
    },
    tipoSituacaoAdicionado() {
      this.tipoSituacao = Object.assign({}, new TipoSituacao());
    }
  },
  created() {
    changePageTitle('Tipos Situação');
  }
}
</script>

<style>

</style>